export enum SubstrateMessageType {
  'transfer_request' = 'transfer_request',
  'sign_payload_request' = 'sign_payload_request'
}
